<template>
  <qx-card-form title="车辆参数"  v-show="showComponent" :defaultContentShow="false" >
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px"></qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      showComponent: false,
      otherFormData: {},
      baseForm: {
        // 品牌名称
        vehicleBrandOptions: [],
        inline: true,
        form: [
          {
            label: '品牌名称',
            value: 'vehicleBrand',
            type: 'select',
            default: '-1',
          },
          {
            label: '品牌型号',
            value: 'brandModel',
            type: 'input',
          },
          {
            label: '车架号',
            value: 'vinNo',
            type: 'input',
          },
          {
            label: '轴数',
            value: 'axleNumber',
            type: 'input',
          },
        ],
        rules: {
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    setList (enums) {
      this.baseForm.vehicleBrandOptions = enums;
    },
    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        if (!this.showComponent) {
          formData = {};
        }
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async sub () {
      let formData = await this.handleSubData();
      formData = {
        ...formData,
        'ext.axleNumber': formData.axleNumber,
        'ext.vehicleBrand': formData.vehicleBrand || '',
        'ext.brandModel': formData.brandModel || '',
      };
      delete formData.axleNumber;
      delete formData.vehicleBrand;
      delete formData.brandModel;
      console.log('参数提交', formData);
      return formData;
    },
    init (data = {}) {
      this.$refs.baseForm.reset();
      // 重置表单为初始状态
      this.resetBaseForm(data.vehicleClass);

      if (data.trailer) {
        data.vinNo = data.trailer.vinNo || '';
      }

      if (data.ext) {
        if (data.ext.axleNumber !== undefined) {
          data.axleNumber = String(data.ext.axleNumber || '');
        }
        if (data.ext.vehicleBrand !== undefined) {
          data.vehicleBrand = data.ext.vehicleBrand || '-1';
        }
        data.brandModel = data.ext.brandModel || '';
      }
      this.$refs.baseForm.setVal(data);
    },
    // 设置所有表单
    resetBaseForm (vehicleClass) {
      if (vehicleClass === '1') {
        this.showComponent = true;
      }
      if (vehicleClass === '2') {
        this.showComponent = false;
      }
    },
    formChange (vehicleClass) {
      this.resetBaseForm(vehicleClass);
    },
    receivedData (vehicleClass) {
      this.formChange(vehicleClass);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
